import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "../WorkoutAdminModal.module.css";
import PresetPickerInline from "./PresetPickerInline";
import ExerciseSelectWithPreview from "./ExerciseSelectWithPreview";
import { formatRepsPerSet, formatRestPerSet, parseRepsPerSet, parseRestPerSet } from "./workoutAdminHelpers";

export default function AddAnonItemModal({
  addAnonItemModalRef,
  closeAddAnonItem,
  anonExerciseItems,
  demoUrlFor,
  ownerId,
  previewExerciseDemo,
  anonItemForm,
  setAnonItemForm,
  applyPreset,
  categories,
  confirmDeletePreset,
  handleAnonCategoryChange,
  handleCreatePreset,
  handleSaveAnonAssignmentItem,
  newPresetForm,
  setNewPresetForm,
  presets,
  presetsLoading,
  saving,
  savingPreset,
  setShowCreatePresetForm,
  showCreatePresetForm,
}) {
  return (
    <div className={styles.innerOverlay} onClick={closeAddAnonItem}>
                      <div
                        className={styles.planModal}
                        ref={addAnonItemModalRef}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="wam-anon-item-title"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className={styles.planModalHeader}>
                          <div>
                            <h3 id="wam-anon-item-title">Adicionar exercício avulso</h3>
                            <p>Inclua um exercício extra apenas para este aluno</p>
                          </div>

                          <button
                            type="button"
                            className={styles.planModalClose}
                            onClick={closeAddAnonItem}
                            aria-label="Fechar modal"
                          >
                            <FontAwesomeIcon icon={faXmark} />
                          </button>
                        </div>

                        <form className={styles.wamForm} onSubmit={handleSaveAnonAssignmentItem}>
                          <div className={styles.wamField}>
                            <label>Categoria</label>
                            <select
                              value={anonItemForm.exercise_id}
                              onChange={(e) => handleAnonCategoryChange(e.target.value)}
                              required
                            >
                              <option value="">Selecione</option>
                              {categories.map((cat) => (
                                <option key={cat.id} value={cat.id}>
                                  {cat.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className={styles.wamField}>
                            <label htmlFor="wam-anon-item-exercise">Exercício</label>
                            <ExerciseSelectWithPreview
                              id="wam-anon-item-exercise"
                              value={anonItemForm.exercise_item_id}
                              onChange={(e) => setAnonItemForm((p) => ({ ...p, exercise_item_id: e.target.value }))}
                              items={anonExerciseItems}
                              demoUrlFor={demoUrlFor}
                              onPreview={previewExerciseDemo}
                              ownerId={ownerId}
                            />
                          </div>

                          <PresetPickerInline
                            presets={presets}
                            loading={presetsLoading}
                            onApply={(preset) => applyPreset(preset, "anon")}
                            onDelete={confirmDeletePreset}
                            showCreateForm={showCreatePresetForm}
                            onToggleCreateForm={() => setShowCreatePresetForm((v) => !v)}
                            newPresetForm={newPresetForm}
                            onChangeNewPresetForm={setNewPresetForm}
                            onSubmitCreate={handleCreatePreset}
                            saving={savingPreset}
                          />

                          <div className={styles.setsRepsRow}>
                            <div className={styles.wamField} style={{width: 80, flexShrink: 0}}>
                              <label>Séries</label>
                              <input type="number" min={1} max={20} value={anonItemForm.sets_planned}
                                onChange={(e) => { const n=Number(e.target.value)||0; setAnonItemForm((p) => ({ ...p, sets_planned: e.target.value, reps_per_set: parseRepsPerSet(p.reps_planned, n), rest_per_set: parseRestPerSet(p.rest_seconds, n) })); }} />
                            </div>
                            {anonItemForm.sets_planned > 0 && (() => {
                              const _sel = anonExerciseItems.find(it => String(it.id) === String(anonItemForm.exercise_item_id));
                              const _isTimed = _sel?.movement_type === 'core';
                              return (
                              <div className={styles.repsPerSetSection}>
                                <label className={styles.repsPerSetSectionLabel}>
                                  {_isTimed ? "⏱ Tempo por série" : "Repetições por série"}
                                </label>
                                {_isTimed && <span className={styles.timedHint}>Insira em segundos - ex: 30s, 45s, 60s</span>}
                                <div className={styles.repsPerSetRow}>
                                  {Array.from({ length: Number(anonItemForm.sets_planned) }).map((_, i) => (
                                    <div key={i} className={styles.repsPerSetItem}>
                                      <span className={styles.repsPerSetLabel}>S{i+1}</span>
                                      <input type="text" className={styles.repsPerSetInput}
                                        value={anonItemForm.reps_per_set[i] ?? ""} placeholder={_isTimed ? "45s" : "-"}
                                        onChange={(e) => { const arr=[...anonItemForm.reps_per_set]; arr[i]=e.target.value; setAnonItemForm((p) => ({ ...p, reps_per_set: arr, reps_planned: formatRepsPerSet(arr) })); }} />
                                    </div>
                                  ))}
                                </div>
                              </div>
                              );
                            })()}
                            {anonItemForm.sets_planned > 0 && (
                              <div className={styles.repsPerSetSection}>
                                <label className={styles.repsPerSetSectionLabel}>Descanso por série (s)</label>
                                <div className={styles.repsPerSetRow}>
                                  {Array.from({ length: Number(anonItemForm.sets_planned) }).map((_, i) => (
                                    <div key={i} className={styles.repsPerSetItem}>
                                      <span className={styles.repsPerSetLabel}>S{i+1}</span>
                                      <input type="number" className={styles.repsPerSetInput}
                                        value={anonItemForm.rest_per_set[i] ?? ""} placeholder="-"
                                        onChange={(e) => { const arr=[...anonItemForm.rest_per_set]; arr[i]=e.target.value; setAnonItemForm((p) => ({ ...p, rest_per_set: arr, rest_seconds: formatRestPerSet(arr) })); }} />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>

                          <div className={styles.wamFormGrid3}>
                            <div className={styles.wamField}>
                              <label>Peso</label>
                              <input
                                type="number"
                                step="0.1"
                                value={anonItemForm.weight_planned}
                                onChange={(e) => setAnonItemForm((p) => ({ ...p, weight_planned: e.target.value }))}
                              />
                            </div>

                            <div className={styles.wamField}>
                              <label>Duração</label>
                              <input
                                type="number"
                                value={anonItemForm.duration_planned}
                                onChange={(e) => setAnonItemForm((p) => ({ ...p, duration_planned: e.target.value }))}
                              />
                            </div>

                            <div className={styles.wamField}>
                              <label>Descanso (s)</label>
                              <input
                                type="number"
                                value={anonItemForm.sets_planned > 0 ? "" : anonItemForm.rest_seconds}
                                placeholder={anonItemForm.sets_planned > 0 ? "Ver por série ↑" : ""}
                                disabled={anonItemForm.sets_planned > 0}
                                onChange={(e) => {
                                  const v = e.target.value;
                                  const n = Number(anonItemForm.sets_planned) || 0;
                                  setAnonItemForm((p) => ({
                                    ...p,
                                    rest_seconds: v,
                                    rest_per_set: n > 0 ? parseRestPerSet(v, n) : [],
                                  }));
                                }}
                              />
                            </div>
                          </div>

                          <div className={styles.wamField}>
                            <label>Observações</label>
                            <textarea
                              rows="3"
                              value={anonItemForm.notes}
                              onChange={(e) => setAnonItemForm((p) => ({ ...p, notes: e.target.value }))}
                            />
                          </div>

                          <div className={styles.actionsRow}>
                            <button type="button" className={`${styles.wamBtn} ${styles.ghost}`} onClick={closeAddAnonItem}>
                              Cancelar
                            </button>
                            <button type="submit" className={`${styles.wamBtn} ${styles.primary}`} disabled={saving}>
                              Adicionar exercício
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
  );
}
